/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceActionsCatalogRequest {
    getFixupPrototypeFunction() { return ResourceActionsCatalogRequest.fixupPrototype; }

    static newInstance(model: Partial<ResourceActionsCatalogRequest>): ResourceActionsCatalogRequest {
        let obj = Object.assign(new ResourceActionsCatalogRequest(), model);
        ResourceActionsCatalogRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceActionsCatalogRequest>): ResourceActionsCatalogRequest {
        if (!model) return null;
        return ResourceActionsCatalogRequest.newInstance(<ResourceActionsCatalogRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceActionsCatalogRequest) {
        if (!obj) return;

        models.ResourceActionsCatalogRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceActionsCatalogRequest): boolean {
        Object.setPrototypeOf(obj, ResourceActionsCatalogRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud or AI platform provider to read the catalog for, for example AWS
     */
    provider: models.InventoryProvider;

    /**
     * Service category to narrow to, for example Compute
     */
    category: string;

    /**
     * Service to narrow to, for example EC2
     */
    resource_type: string;

    /**
     * Provider-native resource type to narrow to, for example Instances
     */
    resource: string;

}
